import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { FormRender, FormRenderDisplayChecker } from '../../../../forms/FormRenderer/types'
import { renderHeaderElements } from '../InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftColumnChange } from '../InputTableLeftColumn/types'
import InputTableSeeMoreSectionsComponent from './Components/InputTableSeeMoreSectionsComponent'
import { Fragment, useCallback } from 'react'
import FormRenderer from '../../../../forms/FormRenderer'

interface InputTableTopHeaderParentProps { }

type InputTableTopHeaderRequiredProps = {
    headerData?: TwinDictionary
    sections: FormRender<any>
    handleChange: InputTableLeftColumnChange
    children?: React.ReactNode
    getCompleteData: () => void
}

type InputTableTopHeaderProps = InputTableTopHeaderParentProps & InputTableTopHeaderRequiredProps

const InputTableTopHeader: React.FC<InputTableTopHeaderProps> = ({ headerData, sections, handleChange, getCompleteData }) => {
    const parsedFields = renderHeaderElements(sections, handleChange, headerData)
    const { displayChecker } = useInputTableTopHeaderLogic()
    return (
        <Fragment>
            <FormRenderer sections={parsedFields} displayChecker={displayChecker} className='input_table_header_new_form' allSectionsInnerClassName='input_table_header_new_form_section'/>
            <InputTableSeeMoreSectionsComponent fields={parsedFields} getCompleteData={getCompleteData} />
        </Fragment>
    )
}

const useInputTableTopHeaderLogic = () => {
    const displayChecker: FormRenderDisplayChecker = useCallback((element) => {
        if (element.hideSectionByDefault) {
            return false
        }
        return true
    }, [])
    return { displayChecker }
}


export default InputTableTopHeader